

















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class Navbar extends Vue {
  @Prop() readonly title!: string;
  @Prop() readonly routes!: { path: string; name: string }[];
  @Prop() readonly user!: any;
  @Prop() readonly logout!: Function;

  get menuItems() {
    return this.routes.filter(r => r.path != "/about");
  }

  get isLoggedIn() {
    return !!this.user;
  }

  get menuBreakpoint() {
    // Regular users will only have access to one route (Associate), so use the medium breakpoint to give them the best
    // view. Any users will more than one route will use the large breakpoint to ensure the route links don't overlap
    if (!this.isLoggedIn) return "md";
    else if (this.routes?.length > 1) return "lg";
    else return "md";
  }
}
